<template>
  <FormSelect :placeholder="placeholder" :options="filteredOptions" v-model="modelValue"/>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FormSelect } from '../Form'
import { CalendarDaysIcon } from '@heroicons/vue/24/solid'
import type { FormSelectOption, FormSelectValue } from '@/interfaces'

const modelValue = defineModel<FormSelectValue>({ required: true });

const options: FormSelectOption[] = [
    { value: 1, label: "Januari", icon: CalendarDaysIcon },
    { value: 2, label: "Februari", icon: CalendarDaysIcon },
    { value: 3, label: "Maart", icon: CalendarDaysIcon },
    { value: 4, label: "April", icon: CalendarDaysIcon },
    { value: 5, label: "Mei", icon: CalendarDaysIcon },
    { value: 6, label: "Juni", icon: CalendarDaysIcon },
    { value: 7, label: "July", icon: CalendarDaysIcon },
    { value: 8, label: "Augustus", icon: CalendarDaysIcon },
    { value: 9, label: "September", icon: CalendarDaysIcon },
    { value: 10, label: "Oktober", icon: CalendarDaysIcon },
    { value: 11, label: "November", icon: CalendarDaysIcon },
    { value: 12, label: "December", icon: CalendarDaysIcon },
];

const { isCurrentYear = false } = defineProps<{
  readonly placeholder: string;
  readonly isCurrentYear?: boolean;
}>();

const filteredOptions = computed(() => {
  if (!isCurrentYear) return options;

  return options.filter(option => option.value as number <= new Date().getMonth() + 1);
});
</script>